import { render, staticRenderFns } from "./ContentGoodsInfo.vue?vue&type=template&id=7683900c&scoped=true&"
import script from "./ContentGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./ContentGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ContentGoodsInfo.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./ContentGoodsInfo.vue?vue&type=style&index=1&id=7683900c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7683900c",
  null
  
)

export default component.exports